import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { ComboLegSelection } from '@/types';

// Mirrors the BE's 2–50 leg limit (combos.validator.js). Exported so the
// builder and the selection handlers share one source of truth instead of
// each hardcoding their own copy.
export const MIN_LEGS = 2;
export const MAX_LEGS = 50;

interface ComboSelectionState {
  isSelectMode: boolean;
  legs: ComboLegSelection[];
}

const initialState: ComboSelectionState = {
  isSelectMode: false,
  legs: [],
};

const comboSelectionSlice = createSlice({
  name: 'comboSelection',
  initialState,
  reducers: {
    /** Turning select mode off also drops any in-progress leg picks. */
    setSelectMode: (state, action: PayloadAction<boolean>) => {
      state.isSelectMode = action.payload;
      if (!action.payload) state.legs = [];
    },
    toggleSelectMode: (state) => {
      state.isSelectMode = !state.isSelectMode;
      if (!state.isSelectMode) state.legs = [];
    },
    /** Add/remove a leg by positionId; caps at MAX_LEGS (mirrors the BE's 2-50 leg limit). */
    toggleLeg: (state, action: PayloadAction<ComboLegSelection>) => {
      const idx = state.legs.findIndex((leg) => leg.positionId === action.payload.positionId);
      if (idx >= 0) {
        state.legs.splice(idx, 1);
      } else if (state.legs.length < MAX_LEGS) {
        state.legs.push(action.payload);
      }
    },
    removeLeg: (state, action: PayloadAction<string>) => {
      state.legs = state.legs.filter((leg) => leg.positionId !== action.payload);
    },
    clearLegs: (state) => {
      state.legs = [];
    },
  },
});

export const { setSelectMode, toggleSelectMode, toggleLeg, removeLeg, clearLegs } =
  comboSelectionSlice.actions;
export default comboSelectionSlice.reducer;
